module.exports = __webpack_public_path__ + "img/double_relay_2.cab75df9.png";